import { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { FormInput, Button } from '../ui';

interface ReminderMinutesInputProps {
  value?: number[];
  onChange: (value: number[]) => void;
  disabled?: boolean;
}

function ReminderMinutesInput({ 
  value = [30], 
  onChange, 
  disabled = false 
}: ReminderMinutesInputProps) {
  const [newMinutes, setNewMinutes] = useState<string>('');

  const handleAdd = () => {
    const minutes = parseInt(newMinutes, 10);
    if (!isNaN(minutes) && minutes > 0) {
      const newValue = [...value, minutes].sort((a, b) => a - b);
      onChange(newValue);
      setNewMinutes('');
    }
  };

  const handleRemove = (index: number) => {
    const newValue = value.filter((_, i) => i !== index);
    onChange(newValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div>
      <div className="flex gap-2 mb-2">
        <FormInput
          type="number"
          min="1"
          placeholder="Adicionar minutos"
          value={newMinutes}
          onChange={(e) => setNewMinutes(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          className="w-40"
        />
        <Button
          type="button"
          onClick={handleAdd}
          disabled={disabled || !newMinutes}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {value.map((minutes, index) => (
          <div
            key={index}
            className="flex items-center gap-1 bg-gray-100 rounded-full px-3 py-1 text-sm"
          >
            <span>{minutes} minutos</span>
            {!disabled && (
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReminderMinutesInput;